import React from "react";
import { Tooltip, InfoText, Icon } from "@weezevent/nacre";
import PropTypes from "prop-types";
import Style from "./infoTextTooltip.module.css";

function Content({ title, subtitle }) {
	return (
		<div className={Style["infotext-tooltip__span-tooltip"]}>
			<div>{title}</div>
			{subtitle && <div className={Style.subtitle}>{subtitle}</div>}
		</div>
	);
}

Content.propTypes = {
	title: PropTypes.string.isRequired,
	subtitle: PropTypes.string
};

Content.defaultProps = {
	subtitle: null
};

const TextTableCell = ({
	title,
	subtitle,
	className,
	showLink,
	linkTooltip,
	onClick,
	disableTooltip
}) => {
	const renderTitle = () => <span>{title}</span>;

	return (
		<InfoText
			className={`${Style["text-table-cell"]} ${className}`}
			subtitle={subtitle}
		>
			<div className={Style["text-icon-container"]}>
				{disableTooltip ? (
					renderTitle()
				) : (
					<Tooltip
						className={Style.tooltip}
						triggerOnHover
						position={"top-start"}
						title={<Content title={title} subtitle={subtitle} />}
						margin={false}
						visible={!disableTooltip}
					>
						{renderTitle()}
					</Tooltip>
				)}
				<Tooltip
					triggerOnHover
					position="top-start"
					title={linkTooltip}
					margin={false}
					visible={!!linkTooltip}
				>
					{showLink && (
						<Icon name="external-link" onClick={onClick} />
					)}
				</Tooltip>
			</div>
		</InfoText>
	);
};

TextTableCell.propTypes = {
	title: PropTypes.node.isRequired,
	subtitle: PropTypes.node,
	className: PropTypes.string,
	showLink: PropTypes.bool,
	onClick: PropTypes.func,
	linkTooltip: PropTypes.string,
	disableTooltip: PropTypes.bool
};

TextTableCell.defaultProps = {
	subtitle: null,
	className: "",
	showLink: false,
	onClick: () => {},
	linkTooltip: "",
	disableTooltip: false
};

export default TextTableCell;
